var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { HttpClient } from "aurelia-http-client";
import { ConfigurationService } from "./configuration.service";
import { autoinject } from "aurelia-framework";
import { buildQueryString } from "aurelia-path";
import { RequestConstants } from "../../configuration/request.constants";
import { CacheClient, CacheKeys } from "./client-caching.service";
import * as _ from "lodash";
import { DialogClientService } from "./dialog-client.service";
import { DialogServiceConstants } from "../../constants/basics/dialog.constants";
import { NotificationClientService, NotificationType } from "./notification-client.service";
import { CloneUtility } from "../../utilities/clone";
import * as UserSettingsConstants from "../../constants/authentication/user-settings.constants";
import { SystemEvents } from "../../models/modules/lotteryplatform-client.models";
var jsonlint = require("./jsonlint.js");
var RequestClient = /** @class */ (function () {
    function RequestClient(httpClient, configurationService, cacheClient, notificationClientService, dialogClient) {
        var _this = this;
        this.httpClient = httpClient;
        this.configurationService = configurationService;
        this.cacheClient = cacheClient;
        this.notificationClientService = notificationClientService;
        this.dialogClient = dialogClient;
        this.enableLoginDialog = true;
        this.isAdmin = false;
        this.isPreview = false;
        this.knownExceptions = [
            "WorkflowAssignmentHasOwnershipAlreadyException",
            "ScopeException",
            "UserHasNoPermissionException",
        ];
        this.apisWithoutRedirectToLogin = [
            UserSettingsConstants.Urls.GetMe
        ];
        this.configurationService.add({
            key: "Access-Control-Allow-Origin",
            value: "*",
            type: RequestConstants.ConfigurationTypes.RequestHeaders
        });
        if (window["server"] && window["server"].iFrameHash) {
            this.configurationService.add({
                key: "iFrameHash",
                value: window["server"].iFrameHash,
                type: RequestConstants.ConfigurationTypes.RequestHeaders
            });
        }
        if (window["server"] && window["server"].referer) {
            this.configurationService.add({
                key: "OriginalReferer",
                value: window["server"].referer,
                type: RequestConstants.ConfigurationTypes.RequestHeaders
            });
        }
        if (window["server"] && window["server"].user && window["server"].user.brandId) {
            this.configurationService.add({
                key: "brandId",
                value: window["server"].user.brandId,
                type: RequestConstants.ConfigurationTypes.RequestHeaders
            });
        }
        this.configurationService.add({
            key: "Timezone",
            value: -new Date().getTimezoneOffset(),
            type: RequestConstants.ConfigurationTypes.RequestHeaders
        });
        this.cacheClient.get(CacheKeys.userId).then(function (x) {
            if (x) {
                _this.configurationService.add({
                    key: "UserId",
                    value: x,
                    type: RequestConstants.ConfigurationTypes.RequestHeaders
                });
            }
        }, function (a) { });
        this.cacheClient.get(CacheKeys.roleId).then(function (x) {
            if (x) {
                _this.configurationService.add({
                    key: "RoleId",
                    value: x,
                    type: RequestConstants.ConfigurationTypes.RequestHeaders
                });
            }
        }, function (a) { });
    }
    RequestClient.prototype.get = function (relativePath, params, urlIsAbsolutePath, canCache, responseType, overrideHeaders) {
        var _this = this;
        if (canCache === void 0) { canCache = true; }
        var request = this.generateRequest(params, relativePath, null, urlIsAbsolutePath, responseType, overrideHeaders).asGet();
        var requestObj = params;
        var key = requestObj && canCache && requestObj.getCacheKey ? requestObj.getCacheKey() : null;
        var model = {
            method: "GET",
            url: relativePath,
            params: params
        };
        var cachePromise = key ? this.cacheClient.get(key) : null;
        var cancelablePromise = new CancelablePromise(function (resolve, reject) {
            if (cachePromise) {
                cachePromise.then(function (x) {
                    if (x) {
                        resolve(x.response);
                    }
                    else {
                        _this.getInternal(relativePath, key, params, request, resolve, reject, model, canCache);
                    }
                }, function (x) {
                    _this.getInternal(relativePath, key, params, request, resolve, reject, model, canCache);
                });
            }
            else {
                _this.getInternal(relativePath, key, params, request, resolve, reject, model, canCache);
            }
        });
        return cancelablePromise;
    };
    RequestClient.prototype.getInternal = function (relativePath, cacheKey, params, request, resolve, reject, model, canCache, cancallabledPromisePrent) {
        var _this = this;
        if (cancallabledPromisePrent === void 0) { cancallabledPromisePrent = null; }
        var sendRequestPromise = this.sendRequest(relativePath, request, model);
        sendRequestPromise.then(function (y) {
            if (y && y.shouldCache && canCache) {
                _this.cacheClient.put(cacheKey, { response: y, request: params }).then(function (x) { }, function (e) { });
            }
            resolve(y);
        }, function (y) {
            reject(y);
        });
    };
    RequestClient.prototype.head = function (relativePath, params) {
        var request = this.generateRequest(params, relativePath, null, null)
            .asHead();
        return this.sendRequest(relativePath, request, {
            method: "HEAD",
            url: relativePath,
            params: params,
        });
    };
    RequestClient.prototype.post = function (relativePath, params, data, urlIsAbsolutePath, responseType) {
        if (urlIsAbsolutePath === void 0) { urlIsAbsolutePath = false; }
        var request = this.generateRequest(params, relativePath, data, urlIsAbsolutePath, responseType, null)
            .asPost();
        return this.sendRequest(relativePath, request, {
            method: "POST",
            url: relativePath,
            params: params,
            data: data
        });
    };
    RequestClient.prototype.postFormData = function (relativePath, requestModel) {
        var requestModel = CloneUtility.cloneObject(requestModel);
        var data = this.appendToFormData(requestModel);
        return this.post(relativePath, {}, data);
    };
    RequestClient.prototype.appendToFormData = function (object, formData, preKey) {
        var _this = this;
        if (formData === void 0) { formData = null; }
        if (preKey === void 0) { preKey = null; }
        var levelOne = false;
        if (formData == null) {
            formData = new FormData();
            levelOne = true;
        }
        var keys = Object.keys(object);
        keys.forEach(function (key) {
            var value = object[key];
            if (Array.isArray(value)) {
                for (var index = value.length - 1; index >= 0; index--) {
                    var element = value[index];
                    _this.appendToFormData(element, formData, (preKey == null ? key : "".concat(preKey, "[").concat(key, "]")) + "[".concat(index, "]"));
                    if (element instanceof File || element instanceof Blob) {
                        value.splice(index, 1);
                    }
                }
            }
            else {
                if (value instanceof File || value instanceof Blob) {
                    formData.append((preKey == null ? key : "".concat(preKey, "[").concat(key, "]")), value);
                    delete object[key];
                }
            }
            if (levelOne && key in object) {
                formData.append(key, JSON.stringify(value));
            }
        });
        return formData;
    };
    RequestClient.prototype.put = function (relativePath, params, data, responseType) {
        var request = this.generateRequest(params, relativePath, data, false, responseType)
            .asPut();
        return this.sendRequest(relativePath, request, {
            method: "PUT",
            url: relativePath,
            params: params,
            data: data
        });
    };
    RequestClient.prototype.postWithProgressCallback = function (relativePath, progressCallback, params, data, responseType) {
        var request = this.generateRequest(params, relativePath, data, false, responseType).asPost();
        // set progress callback
        if (progressCallback) {
            request.withProgressCallback(progressCallback);
        }
        return this.sendRequest(relativePath, request, {
            method: "PUT",
            url: relativePath,
            params: params,
            data: data
        });
    };
    RequestClient.prototype.getApiCallTemplate = function (urlIsAbsolutePath) {
        if (urlIsAbsolutePath) {
            return RequestConstants.AbsoluteApiCallTemplate;
        }
        return RequestConstants.ApiCallTemplate;
    };
    RequestClient.prototype.getRequestHeaders = function (scope) {
        return this.configurationService.getList(RequestConstants.ConfigurationTypes.RequestHeaders, scope);
    };
    RequestClient.prototype.constructRelativePath = function (params, relativePath) {
        var queryString = (params) ? buildQueryString(params) : "";
        queryString = queryString === "" ? "" : "?" + queryString;
        queryString = queryString.replace(new RegExp("%5B%5D", "g"), "");
        return relativePath + queryString;
    };
    RequestClient.prototype.generateUrl = function (params, relativePath, urlIsAbsolutePath) {
        var apiBaseTemplate = this.getApiCallTemplate(urlIsAbsolutePath);
        relativePath = this.constructRelativePath(params, relativePath);
        var urlParams = {};
        urlParams[RequestConstants.UrlParameters.RelativePath] = relativePath;
        return _.template(apiBaseTemplate)(urlParams);
    };
    ;
    RequestClient.prototype.generateRequest = function (params, relativePath, body, urlIsAbsolutePath, responseType, overrideHeaders) {
        var url = this.generateUrl(params, relativePath, urlIsAbsolutePath);
        var headers = overrideHeaders ? overrideHeaders : this.getRequestHeaders();
        var request = this.httpClient.createRequest(url);
        if (headers) {
            for (var header in headers) {
                if (header in headers) {
                    request.withHeader(header, headers[header]);
                }
            }
        }
        if (body) {
            request.withContent(body);
        }
        if (responseType) {
            request.withResponseType(responseType);
        }
        // hack to identify ajax requests to prevent redirect while 403 error
        // https://johnnyreilly.com/how-to-make-azure-ad-403
        // For more information, refer to LotteryPlatform.Models.Authentication.IdentityConfigurator C# file
        request.withHeader("X-Requested-With", "XMLHttpRequest");
        return request;
    };
    RequestClient.prototype.sendRequest = function (relativePath, request, model) {
        var _this = this;
        var cancallablePromise = request.send();
        return new CancelablePromise(function (resolve, reject) {
            cancallablePromise
                .then(function (response) {
                var result;
                try {
                    result = response.content;
                }
                catch (error) {
                    if (response.response && response.mimeType === "application/json") {
                        try {
                            result = JSON.parse(response.response);
                        }
                        catch (ex) {
                            console.error(ex);
                            result = jsonlint.parse(response.response);
                        }
                    }
                    else if (response.response && response.mimeType === "text/html") {
                        result = response.response;
                    }
                    else {
                        result = null;
                    }
                }
                resolve(result);
            }, function (response) {
                var result;
                try {
                    if (response.statusCode && response.statusCode == 401) {
                        if (_this.isAdmin && !_this.isPreview) {
                            if (window.location.pathname != "/") {
                                window.location.href = "/";
                            }
                            reject(response);
                        }
                        else {
                            if (!window["SystemJS"]) {
                                require("" + "../../views/app/client/dialogs/login-dialog");
                            }
                            if (_this.enableLoginDialog && _this.dialogClient.view != DialogServiceConstants.URLs.LoginDialog) {
                                _this.dialogClient.show(DialogServiceConstants.URLs.LoginDialog, model);
                                var func = function () {
                                    reject();
                                    _this.dialogClient.unSubscribeHide(func);
                                };
                                _this.dialogClient.subscribeHide(func);
                            }
                            else {
                                window.dispatchEvent(new CustomEvent(SystemEvents.externalLogin, { detail: model }));
                                reject();
                            }
                        }
                    }
                    else if (response.statusCode && response.statusCode == 403) {
                        _this.notificationClientService.show("Access Forbidden!", "You don't have access to perform this operation", NotificationType.Error, 5000);
                        reject();
                    }
                    else if (response.statusCode && response.statusCode == 400 && response.content) {
                        reject(response.content);
                    }
                    else {
                        if (response.content) {
                            if (_this.knownExceptions.indexOf(response.content.exception) != -1) {
                                _this.showKnowException(response.content);
                            }
                        }
                        reject(response);
                    }
                }
                catch (error) {
                    if (response.response && response.mimeType === "application/json") {
                        result = JSON.parse(response.response);
                    }
                    else if (response.response && response.mimeType === "text/html") {
                        result = response.response;
                    }
                    else {
                        result = null;
                    }
                    reject(result);
                }
            });
        });
    };
    RequestClient.prototype.downloadFile = function (blob, fileNameWithoutExtension) {
        var link = document.createElement('a');
        link.download = fileNameWithoutExtension;
        link.href = window.URL.createObjectURL(blob);
        link.click();
    };
    RequestClient.prototype.showKnowException = function (item) {
        this.notificationClientService.show("Error", item.details, NotificationType.Error, 5000);
    };
    RequestClient = __decorate([
        autoinject,
        __metadata("design:paramtypes", [HttpClient,
            ConfigurationService,
            CacheClient,
            NotificationClientService,
            DialogClientService])
    ], RequestClient);
    return RequestClient;
}());
export { RequestClient };
var CancelablePromise = /** @class */ (function () {
    function CancelablePromise(executor) {
        this[_a] = 'Promise';
        this._canceled = false;
        this._promise = new Promise(executor);
    }
    CancelablePromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        var chain = new CancelablePromise(function (resolve, reject) {
            _this._promise.then(function (value) {
                if (_this._canceled)
                    return chain.cancel();
                resolve(onfulfilled ? onfulfilled(value) : value);
            }, function (reason) {
                if (_this._canceled)
                    return chain.cancel();
                if (onrejected)
                    resolve(onrejected(reason));
                else
                    reject(reason);
            });
        });
        return chain;
    };
    CancelablePromise.prototype.catch = function (onrejected) {
        return this.then(null, onrejected);
    };
    CancelablePromise.prototype.finally = function (onfinally) {
        var wrap = function (cb) {
            return function (x) { try {
                cb === null || cb === void 0 ? void 0 : cb();
            }
            finally {
                return x;
            } };
        };
        return this.then(function (v) { return wrap(onfinally)(v); }, function (e) { throw wrap(onfinally)(e); });
    };
    CancelablePromise.prototype.cancel = function () { this._canceled = true; return this; };
    var _a;
    _a = Symbol.toStringTag;
    CancelablePromise.all = Promise.all.bind(Promise);
    CancelablePromise.race = Promise.race.bind(Promise);
    CancelablePromise.resolve = Promise.resolve.bind(Promise);
    CancelablePromise.reject = Promise.reject.bind(Promise);
    return CancelablePromise;
}());
export { CancelablePromise };
export var ResponseType;
(function (ResponseType) {
    ResponseType["DOMString"] = "text";
    ResponseType["ArrayBuffer"] = "arraybuffer";
    ResponseType["Blob"] = "blob";
    ResponseType["Document"] = "document";
    ResponseType["JObject"] = "json";
})(ResponseType || (ResponseType = {}));
